import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'

export const StyledBoxCenter = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'center',
  padding: '2rem',
}))

export const StyledTitle = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  padding: '0.5rem',
  width: '100%',
  backgroundColor: theme.palette.grey[300],
  borderRadius: '0.3rem',
}))

export const StyledSubtitle = styled(Box)(({ theme }) => ({
  width: '100%',
  borderBottom: '1px solid',
  borderColor: theme.palette.grey[300],
}))

export const StyledPrintContent = styled('div')`
  .content__wrapper.print__wrapper {
    margin-top: 5rem;
    position: relative;

    @media print {
      position: relative;

      html,
      body {
        height: initial !important;
        overflow: initial !important;
        -webkit-print-color-adjust: exact;
      }
    }

    @media print {
      .page-break {
        page-break-inside: avoid;
      }

      .content__wrapper__segment {
        margin-top: 2rem;
      }
    }

    .content__wrapper__segment {
      margin-top: 2rem;
    }
  }

  .print__wrapper {
    @media print {
      margin-top: 0 !important;
    }
  }

  @page {
    size: auto;
    margin: 20mm;
  }
`
